import React from 'react';
import { Section } from './ui/Section';
export function Transformation() {
  return <Section className="bg-stone-900 text-white text-center" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-176">
          La transformación (realista)
        </h2>
        <p className="text-xl text-stone-300 mb-12 leading-relaxed" data-id="element-177">
          No vas a "convertirte en experto". Vas a tener algo mejor: <br data-id="element-178" />
          <span className="text-amber-400 font-bold text-2xl mt-2 block" data-id="element-179">
            Un sistema para no quedarte en blanco.
          </span>
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center" data-id="element-180">
          {[{
          label: 'Menos tiempo',
          val: 'Escribiendo'
        }, {
          label: 'Más claridad',
          val: 'Para ejecutar'
        }, {
          label: 'Mensajes',
          val: 'Humanos'
        }, {
          label: 'Decisiones',
          val: 'Operativas'
        }].map((item, i) => <div key={i} className="bg-stone-800 p-6 rounded-xl border border-stone-700" data-id="element-181">
              <div className="text-amber-400 font-bold text-lg mb-1" data-id="element-182">
                {item.label}
              </div>
              <div className="text-stone-400 text-sm" data-id="element-183">{item.val}</div>
            </div>)}
        </div>
      </div>
    </Section>;
}